import './survey.scss';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import decodeToken from '../../../../utils/decode-token';
import Wadsworth from '../../../organisms/role-hac/wadsworth/wadsworth';
import Footer from "../../../organisms/footer/footer";
import Survey from "../../../organisms/common/survey/survey";

const HacSurvey = () => {
  const location = useLocation();

  const token = sessionStorage.getItem('token') || null;
  const decoded = token ? decodeToken(token) : null;
  const role = decoded?.role || null;

  const surveyId = location.state?.surveyId ?? null;
  console.log(surveyId);

  if (!surveyId) {
    return <Navigate to="/hac/main" />;
  }

  return (
    <>
      {token ? (
        <div className="App">
          <Header />
          <main className="legal">
            {role === 'hac' && <Wadsworth />}
            <section className="survey">
              <Survey surveyId={surveyId} />
            </section>
          </main>
          <Footer />
        </div>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
};

export default HacSurvey;
